import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";
import {
  formatNumber,
  truncateToTwoDecimals,
} from "../../../../../../utility/helper";
import { useSelector } from "react-redux";
import {
  wealthAssetTypeOption,
  sectorss,
} from "../../../../../../utility/data";
// import moment from "moment";

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const { roi, date } = payload[0].payload;
    const roiPercentage = truncateToTwoDecimals(roi);

    return (
      <div
        style={{
          padding: "10px",
          color: "#333",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
        }}
      >
        <div className="flex gap-2">
          <strong style={{ margin: 0, color: "#333" }}>ROI:</strong>
          <p style={{ color: "#333" }}>{roiPercentage}%</p>
        </div>
        <div className="flex gap-2">
          <strong style={{ margin: 0, color: "#333" }}>Date:</strong>
          <p style={{ color: "#333" }}>{date}</p>
        </div>
      </div>
    );
  }
  return null;
};

const RechartExample = ({ graphDetails, groupsData }) => {
  const filteredGraphData = graphDetails?.graph_data?.filter(
    (entry) => typeof entry.roi === "number"
  );

  const [activeIndex, setActiveIndex] = useState({});
  const [chartsData, setChartsData] = useState([]);
  const theme = useSelector((state) => state.theme.mode);

  useEffect(() => {
    if (graphDetails) {
      const pieData = graphDetails.pie_chart_data || {};

      const getMappedName = (list, key) =>
        list?.find((item) => item.value === key)?.name || key;

      const mapWithColors = (data, baseColors) =>
        data?.map((item, index) => ({
          ...item,
          color: baseColors[index % baseColors.length], // repeat color
        })) || [];

      const sectorsColors = [
        "#FF85B6",
        "#57FFFF",
        "#FFBF00",
        "#007BFF",
        "#1ABC9C",
        "#FF4500",
        "#32CD32",
        "#8A2BE2",
        "#FFD700",
        "#DC143C",
        "rgb(133, 220, 20)",
        "rgb(220, 20, 170)",
      ];

      const structureColors = [
        "#FFBF00",
        "#FF85B6",
        "#57FFFF",
        "#32CD32",
        "#8A2BE2",
        "#FF4500",
      ];

      const allocationColors = [...sectorsColors]; // reuse same palette

      setChartsData([
        {
          title: "Sector",
          data: mapWithColors(
            pieData.sectors?.map((item) => ({
              name: item.sector,
              value:
                item.percentage != null
                  ? parseFloat(item.percentage?.toFixed(2))
                  : 0,
              displayName: getMappedName(sectorss, item.sector),
            })),
            sectorsColors
          ),
          colors: sectorsColors,
        },
        {
          title: "Structure",
          data: mapWithColors(
            pieData.structure?.map((item) => ({
              name: `Group ${item.group}`,
              value:
                item.percentage != null
                  ? parseFloat(item.percentage.toFixed(2))
                  : 0,
              displayName: getMappedName(
                groupsData?.map((g) => ({
                  name: g.name,
                  value: `Group ${g.id}`,
                })),
                `Group ${item.group}`
              ),
            })),
            structureColors
          ),
          colors: structureColors,
        },
        {
          title: "Allocation",
          data: mapWithColors(
            pieData.allocaton?.map((item) => ({
              name: item.asset_name,
              value:
                item.percentage != null
                  ? parseFloat(item.percentage.toFixed(2))
                  : 0,
              displayName: getMappedName(
                wealthAssetTypeOption,
                item.asset_class
              ),
            })),
            allocationColors
          ),
          colors: allocationColors,
        },
      ]);
    }
  }, [graphDetails, groupsData]);

  // useEffect(() => {
  //   if (graphDetails) {
  //     const pieData = graphDetails.pie_chart_data || {};
  //     const getMappedName = (list, key) =>
  //       list?.find((item) => item.value === key)?.name || key;
  //     setChartsData([
  //       {
  //         title: "Sector",
  //         data:
  //           pieData.sectors?.map((item) => ({
  //             name: item.sector,
  //             value:
  //               item.percentage != null
  //                 ? parseFloat(item.percentage.toFixed(2))
  //                 : 0,
  //             displayName: getMappedName(sectorss, item.sector),
  //           })) || [],
  //         colors: [
  //           "#FF85B6",
  //           "#57FFFF",
  //           "#FFBF00",
  //           "#007BFF",
  //           "#1ABC9C",
  //           "#FF4500",
  //           "#32CD32",
  //           "#8A2BE2",
  //           "#FFD700",
  //           "#DC143C",
  //           "rgb(133, 220, 20)",
  //           "rgb(220, 20, 170)",
  //         ],
  //       },
  //       {
  //         title: "Structure",
  //         data:
  //           pieData.structure?.map((item) => ({
  //             name: `Group ${item.group}`,
  //             value:
  //               item.percentage != null
  //                 ? parseFloat(item.percentage.toFixed(2))
  //                 : 0,
  //             displayName: getMappedName(
  //               groupsData?.map((g) => ({
  //                 name: g.name,
  //                 value: `Group ${g.id}`,
  //               })),
  //               `Group ${item.group}`
  //             ),
  //           })) || [],
  //         colors: [
  //           "#FFBF00",
  //           "#FF85B6",
  //           "#57FFFF",
  //           "#32CD32",
  //           "#8A2BE2",
  //           "#FF4500",
  //         ],
  //       },
  //       {
  //         title: "Allocation",
  //         data:
  //           pieData.allocaton?.map((item) => ({
  //             name: item.asset_name,
  //             value:
  //               item.percentage != null
  //                 ? parseFloat(item.percentage.toFixed(2))
  //                 : 0,
  //             displayName: getMappedName(wealthAssetTypeOption, item.asset_class),
  //           })) || [],
  //         colors: ["#FF85B6", "#57FFFF", "#FFBF00", "#007BFF", "#1ABC9C"],
  //       },
  //     ]);
  //   }
  // }, [graphDetails, groupsData]);

  const handleHover = (chartIndex, index) => {
    setActiveIndex((prev) => {
      const newState = { ...prev };
      if (typeof index === "number") {
        newState[chartIndex] = index;
      } else {
        delete newState[chartIndex];
      }
      return newState;
    });
  };

  return (
    <div className="flex gap-4">
      <div className="w-full pt-20">
        {/* <button onClick={onBack}>
          <FaArrowLeft fontSize={24} />
        </button> */}
        {/* <div className="grid grid-cols-2 mb-6 pl-12 max-w-xl font-bold">
          <div>Selected Wealth</div>
          <div>CHF 22040</div>
        </div>
        <div className="md:w-2/3 w-[calc(100%-3rem)] overflow-x-auto mb-6 ml-14">
          <table className="min-w-[670px] text-base border-collapse text-info dark:text-white">
            <thead>
              <tr>
                <th className="text-left pr-4"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pb-2">The selected has increased by</td>
                <td className="pb-2 text-lightPrimary dark:text-primary-gradient">
                  {formatNumber(fortuneData?.fortune_increased ?? "#######")}{" "}
                  CHF
                </td>
                <td className="pb-2">Year to date</td>
              </tr>
              <tr>
                <td className="pb-2">Due to total profit of</td>
                <td className="pb-2 text-lightPrimary dark:text-primary-gradient">
                  {formatNumber(fortuneData?.due_total ?? "#######")} CHF
                </td>
                <td className="pl-4 text-center pb-2 text-lightPrimary dark:text-primary-gradient">
                  16%
                </td>
                <td className="pb-2">ROI</td>
                <td className=" pb-2 text-lightPrimary dark:text-primary-gradient">
                  {formatNumber(fortuneData?.net_flow ?? "#######")} CHF
                </td>
              </tr>
            </tbody>
          </table>
        </div> */}
        <div className="pt-3">
          <ResponsiveContainer height={400}>
            <LineChart data={filteredGraphData} className="pt-8">
              <defs>
                {theme === "light" ? (
                  <linearGradient
                    id="colorGradient"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                  >
                    <stop offset="0%" stopColor="#72b4eb" />
                    <stop offset="40%" stopColor="#57acf1" />
                    <stop offset="100%" stopColor="#47C1F0" />
                  </linearGradient>
                ) : (
                  <linearGradient
                    id="colorGradient"
                    x1="0"
                    y1="0"
                    x2="1"
                    y2="0"
                  >
                    <stop offset="0%" stopColor="#cce9ff" />
                    <stop offset="40%" stopColor="rgb(130, 188, 235)" />
                    <stop offset="60%" stopColor="#6eb6f1" />
                    <stop offset="80%" stopColor="#3a91d9" />
                    <stop offset="100%" stopColor="#47C1F0" />
                  </linearGradient>
                )}
              </defs>

              <CartesianGrid strokeDasharray="0 1" stroke="#ccc" />
              <XAxis
                dataKey="date"
                tick={({ x, y, payload }) => (
                  <text
                    x={x - 30}
                    y={y + 10}
                    fill={
                      theme === "dark"
                        ? "rgb(206, 206, 206)"
                        : "rgb(77, 76, 83)"
                    }
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={12}
                  >
                    {""}
                  </text>
                )}
                axisLine={false}
                tickFormatter={(value) => value && ""}
                tickLine={false}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                tick={({ x, y, payload }) => (
                  <text
                    x={x - 45}
                    y={y}
                    fill={
                      theme === "dark"
                        ? "rgb(206, 206, 206)"
                        : "rgb(77, 76, 83)"
                    }
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={12}
                  >
                    {payload.value}%
                  </text>
                )}
                tickFormatter={(value) => `${value}%`}
              />
              <Tooltip content={<CustomTooltip />} cursor={false} />
              <Line
                type="linear"
                dataKey="roi"
                stroke="url(#colorGradient)"
                dot={false}
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
          <div className="flex md:justify-center font-semibold items-center text-info dark:text-grey text-center md:flex-row flex-col md:gap-28 gap-4 mt-2">
            <div className="flex flex-col gap-1">
              <span>Unrealized profit</span>
              <span className="text-lightPrimary dark:text-primary-gradient">
                {graphDetails?.unrealized
                  ? formatNumber(graphDetails?.unrealized)
                  : "0"}{" "}
                CHF
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span>Sale</span>
              <span className="text-lightPrimary dark:text-primary-gradient">
                {graphDetails?.realized
                  ? formatNumber(graphDetails?.realized)
                  : "0"}{" "}
                CHF
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span>Income</span>
              <span className="text-lightPrimary dark:text-primary-gradient">
                {graphDetails?.income
                  ? formatNumber(graphDetails?.income)
                  : "0"}{" "}
                CHF
              </span>
            </div>
            <div className="flex flex-col gap-1">
              <span>Expense</span>
              <span className="text-expense dark:text-warning">
                {graphDetails?.expense
                  ? formatNumber(
                      truncateToTwoDecimals(Number(graphDetails.expense))
                    )
                  : "0"}{" "}
                CHF
              </span>
            </div>
          </div>
        </div>
        <div className="flex flex-col md:flex-row md:justify-around gap-10 mt-16">
          {chartsData.map((chart, chartIndex) => (
            <div key={chartIndex} className="text-center w-full md:w-1/3">
              <h3 className="text-lightPrimary dark:text-primary-gradient font-bold mb-2">
                {chart.title}
              </h3>
              <ResponsiveContainer height={200}>
                <PieChart>
                  <Tooltip
                    cursor={{ fill: "none" }}
                    content={({ payload }) => {
                      if (!payload || payload.length === 0) return null;
                      const data = payload[0]?.payload;
                      return (
                        <div className="bg-white text-info p-4 rounded shadow-md text-sm">
                          <strong>
                            {data?.displayName || data?.name}: {data?.value}%
                          </strong>
                        </div>
                      );
                    }}
                  />
                  <Pie
                    data={chart.data}
                    cx="50%"
                    cy="50%"
                    innerRadius={50}
                    outerRadius={70}
                    paddingAngle={2}
                    dataKey="value"
                    onMouseEnter={(_, index) => handleHover(chartIndex, index)}
                    onMouseLeave={() => handleHover(chartIndex)}
                    activeIndex={
                      activeIndex[chartIndex] !== undefined
                        ? activeIndex[chartIndex]
                        : null
                    }
                    activeShape={{ outerRadius: 80 }}
                  >
                    {chart.data.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={chart.colors[index]} />
                    ))}
                  </Pie>
                </PieChart>
              </ResponsiveContainer>
              <div className="flex gap-3 justify-center flex-wrap">
                {chart.data.map((entry, index) => {
                  return (
                    <div
                      key={index}
                      className="md:flex gap-2 items-center mb-2"
                    >
                      <span
                        className="hidden md:block"
                        style={{
                          width: 12,
                          height: 12,
                          backgroundColor: chart.colors[index],
                          borderRadius: 2,
                        }}
                      ></span>
                      <span className="text-lightPrimary dark:text-grey text-sm">
                        {entry.displayName || entry.name}
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RechartExample;
